import {
    FETCH_CHAINS,
    SAVE_CHAIN,
    DELETE_CHAIN,
    SET_CURRENT_CHAIN_ID,
    FETCH_CHAIN
} from '../types';
import api from '../api';

export const fetchChains = (ids = []) => {
    return {
        type: FETCH_CHAINS,
        payload: api.chains.getAll(ids),
    };
};

export const fetchChain = chainId => {
    return {
        type: FETCH_CHAIN,
        payload: api.chains.getAll([chainId]),
    };
};

export const saveChain = (chain) => {
    if (chain.id) {
        return {
            type: SAVE_CHAIN,
            payload: api.chains.update(chain),
            meta: { chainId: chain.id, toastSuccess: true }
        };
    } else {
        return {
            type: SAVE_CHAIN,
            payload: api.chains.create(chain),
            meta: { toastSuccess: true }
        };
    }
};

export const deleteChain = (chainId) => {
    return {
        type: DELETE_CHAIN,
        payload: api.chains.delete(chainId),
        meta: { chainId, toastSuccess: true }
    };
};

export const setCurrentChainId = chainId => {
    return {
        type: SET_CURRENT_CHAIN_ID,
        payload: chainId
    };
};
